import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { useLogo } from '../context/PortalDataContext';
import { useIsPillBorderRadius } from '../hooks/useIsPillBorderRadius';
import { usePortalNavigation } from '../hooks/usePortalNavigation';
import { PortalsSideNav } from './PortalsNav';
import { MyAccountPopover } from './MyAccountPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PortalsHeader() {
  var _ref, _logo$alt;
  const logo = useLogo();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: "60px",
    backgroundColor: "fill-surface-recessed",
    flexShrink: "0",
    paddingInlineStart: '200',
    paddingInlineEnd: '400',
    children: [/*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      alignItems: "center",
      children: logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_jsx("img", {
        src: logo.src,
        alt: (_ref = (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : logo.name) !== null && _ref !== void 0 ? _ref : 'Logo',
        style: {
          maxHeight: '44px',
          maxWidth: '150px'
        }
      }) : null
    }), /*#__PURE__*/_jsx(Flex, {
      flexGrow: "1"
    }), /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      paddingInline: "300",
      children: /*#__PURE__*/_jsx(MyAccountPopover, {})
    })]
  });
}
export function PortalsAppLayout({
  children,
  history,
  currentPathname
}) {
  const isPill = useIsPillBorderRadius();
  const {
    shouldShowSideNav
  } = usePortalNavigation(currentPathname);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    blockSize: "100vh",
    overflow: "hidden",
    backgroundColor: "fill-surface-recessed",
    children: [/*#__PURE__*/_jsx(PortalsHeader, {}), /*#__PURE__*/_jsxs(Flex, {
      flexGrow: "1",
      overflow: "hidden",
      minBlockSize: "0px",
      children: [shouldShowSideNav && /*#__PURE__*/_jsx(View, {
        inlineSize: "60px",
        flexShrink: 0,
        paddingBlock: "400",
        children: /*#__PURE__*/_jsx(PortalsSideNav, {
          history: history,
          currentPathname: currentPathname
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexGrow: "1",
        backgroundColor: "fill-surface-default",
        borderStartStartRadius: shouldShowSideNav ? isPill ? '0' : '400' : undefined,
        overflow: "auto",
        children: /*#__PURE__*/_jsx(View, {
          as: "main",
          flexGrow: "1",
          minInlineSize: "0px",
          children: children
        })
      })]
    })]
  });
}